import { useMemo } from "react";

import { useGetUser } from "@/hooks/api/user/useGetUser";

const useUserInitials = () => {
  const { data: userData } = useGetUser();
  const userInitials = useMemo(
    () =>
      `${userData?.first_name ? userData.first_name[0] : "?"}${userData?.last_name ? userData.last_name[0] : ""}`.toUpperCase(),
    [userData],
  );

  return { userInitials };
};

export default useUserInitials;
